<div [formGroup]="form">
  <section class="photo-upload">
    <ng-container *ngIf="!disableDropzone && !readOnly">
      <dropzone #dropzoneRef
                id="image-upload-container"
                message="{{'$import_upload' | translate}}"
                [useDropzoneClass]="true"
                [placeholder]="placeholderImage"
                [disabled]="disableDropzone || readOnly"
                [config]="dropzoneConfig"
                (success)="onUploadSuccess($event)"
                (error)="onUploadFailure($event)">
      </dropzone>

      <div *ngIf="errorMessage" class="error-msg">
        <mat-icon>warning</mat-icon>
        <span [innerHtml]="errorMessage"></span>
      </div>
      <p *ngIf="disableDropzone || readOnly" [innerHTML]="'$photo_upload_no_more_photos' | translate"></p>
    </ng-container>

    <div class="photo-gallery" *ngFor="let question of questionGroupCopy?.questions">
      <ng-container *ngFor="let answer of question.answers">
        <div *ngIf="answer.text" [formGroupName]="question.group" class="photo-item">
          <div class="img-container">
            <img [src]="answer.text" />
            <button mat-icon-button class="btn-delete" (click)="removeFile(question, answer.text)" *ngIf="!readOnly"><mat-icon>close</mat-icon></button>
          </div>
          <ng-container *ngFor="let childQuestion of question?.childQuestions">
            <div *ngFor="let childAnswer of childQuestion.answers">
              <mat-form-field class="form-field form-full-width-field image-description">
                <mat-label [innerHTML]="'$photo_upload_description_label' | translate"></mat-label>
                <textarea matInput type="textarea"
                          [value]="childAnswer.text || ''"
                          (change)="onKeyPress($event.target.value, null, question.id+'-'+childQuestion.id, childAnswer)"
                          rows="2"
                          [disabled]="readOnly">
                </textarea>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </section>
</div>
